import { SpeedTest, SpeedTestPostResult } from "../model/Speedtest";
import { apiService } from "./ApiService";

export const speedtest = (speedtests: SpeedTest[]) => {
  return apiService.post<SpeedTestPostResult>({
    path: `v1/me/speedtests`,
    body: {
      speedtests,
    },
  });
};
